export class CustomerPaymentMileStones {
    PaymentTermID: number;
    Description: string;
    Percentage: number;
    AmountExclusiveOfTax: number;
    OtherCharges: number;
    AmountTax: number;
    OtherChargesTax: number;
    AmountInclusiveOfTax: number;
    PayableAmountInclusiveOfTax: number;
    LatePaymentCharges: number;
    IsPaid: boolean;
    PaidAmount: number;
    IsDocumentsApproved: boolean;
    DueDate: string | Date | null; // instead of boolean;
    UnderConciliationAmount: number;
    IsOtherCharges: boolean;
    TDS: number;
    IsTDSApplicable: boolean;
    PANNo: string;
    IsChallanUploaded : boolean;
    IsCertificateUploaded : boolean;
    IsChallanApproved : boolean;
    IsCertificateApproved : boolean;
    IsChallanRejected : boolean;
    IsCertificateRejected : boolean;
    ChallanRejectedReason : string
    CertificateRejectedReason : string;
    CanEnablePayButton: boolean;
    TaxPercentage: number;
}
